import { render, staticRenderFns } from "./CourierEdit.vue?vue&type=template&id=d92273c4&"
import script from "./CourierEdit.vue?vue&type=script&lang=js&"
export * from "./CourierEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports